"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonTests = void 0;
var utils_1 = require("../../support/utils");
var am_button_1 = require("./am-button");
var pm_button_1 = require("./pm-button");
var blank_button_1 = require("./blank-button");
var toggle_polyfill_1 = require("./toggle-polyfill");
var ButtonTests = /** @class */ (function (_super) {
    __extends(ButtonTests, _super);
    function ButtonTests(utils) {
        var _this = _super.call(this, utils) || this;
        _this.am = function () { return (0, am_button_1.button_am)(utils); };
        _this.pm = function () { return (0, pm_button_1.button_pm)(utils); };
        _this.blank = function () { return (0, blank_button_1.button_blank)(utils); };
        _this.togglePolyfill = function () { return (0, toggle_polyfill_1.toggleButton)(utils); };
        return _this;
    }
    return ButtonTests;
}(utils_1.TestSuite));
exports.ButtonTests = ButtonTests;
